import React from "react";
import * as Sentry from "@sentry/react";
import { AlertTriangle, RefreshCcw } from "lucide-react";

interface Props {
  children: React.ReactNode;
}

const ErrorFallback = () => (
  <div className="h-screen w-full flex items-center justify-center bg-juris-soft p-4 font-sans">
    <div className="bg-panel rounded-2xl shadow-xl p-8 max-w-md w-full text-center border border-line motion-micro-scale">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-warning-soft mb-6">
        <AlertTriangle className="h-8 w-8 text-warning" />
      </div>
      <h2 className="text-2xl font-extrabold text-ink mb-2 tracking-tight">Vaya, algo no ha salido bien</h2>
      <p className="text-muted mb-8 leading-relaxed">
        Juris ha experimentado un error inesperado. Hemos tomado nota técnica para solucionarlo cuanto antes.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="w-full py-4 bg-action text-white font-bold rounded-xl hover:bg-action-hover transition-all shadow-lg shadow-black flex items-center justify-center gap-2 transform active:scale-[0.98]"
      >
        <RefreshCcw size={20} />
        Recargar aplicación
      </button>
      <p className="mt-6 text-xs text-muted">
        Si el error persiste, por favor contacta con soporte.
      </p>
    </div>
  </div>
);

export const SentryErrorBoundary: React.FC<Props> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
